import React from 'react'
import Link from 'next/link'
import { FaXTwitter, FaLinkedinIn } from 'react-icons/fa6'
import { MdEmail } from 'react-icons/md'

interface IProps {
  url: string
  title: string
}

const Social = (props: IProps) => {
  const { url, title } = props
  const socialURL = encodeURIComponent(url)
  const socialText = encodeURIComponent(title)
  return (
    <div className='mx-auto flex place-content-end w-8/12 md:w-10/12 max-w-screen-xl py-5'>
      {/* <!-- Share --> */}
      <div className='flex md:justify-between items-center '>
        <span className='dark:text-jacarta-200 text-sm font-bold px-10'>
          Compartir:
        </span>
        <div className='flex space-x-2 sm:justify-center'>
          <Link
            href={`https://twitter.com/intent/tweet?url=${socialURL}&text=${socialText}`}
            className='group dark:bg-jacarta-700 dark:border-jacarta-600 dark:hover:bg-accent border-jacarta-100 hover:bg-accent inline-flex h-10 w-10 items-center justify-center rounded-full cursor-pointer border bg-white transition-colors hover:border-transparent'
          >
            <FaXTwitter className='fill-jacarta-400 h-4 w-4 transition-colors group-hover:fill-white dark:group-hover:fill-white' />
          </Link>

          <Link
            href={`https://www.linkedin.com/shareArticle?mini=true&url=${socialURL}&title=${socialText}`}
            className='group dark:bg-jacarta-700 dark:border-jacarta-600 dark:hover:bg-accent border-jacarta-100 hover:bg-accent inline-flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent cursor-pointer'
          >
            <FaLinkedinIn className='fill-jacarta-400 h-4 w-4 transition-colors group-hover:fill-white dark:group-hover:fill-white' />
          </Link>

          <Link
            href={`mailto:?subject=${socialText}&body=${encodeURIComponent(
              `¡Echa un vistazo a este artículo interesante!\n\n${title}\n${url}`
            )}`}
            className='group dark:bg-jacarta-700 dark:border-jacarta-600 dark:hover:bg-accent border-jacarta-100 hover:bg-accent inline-flex h-10 w-10 items-center justify-center rounded-full border bg-white transition-colors hover:border-transparent cursor-pointer'
          >
            <MdEmail className='fill-jacarta-400 h-4 w-4 transition-colors group-hover:fill-white dark:group-hover:fill-white' />
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Social
